import React, { useEffect, useState, useCallback, useRef } from "react";

import { QueryContent, QuerySection, QuerySectionHeader } from "../../query";

import { SaveQueryBar } from "../../workflow";

import { useSchema } from "../../../../../hooks/projects";
import { TableField2 } from "../../fields/queryfields";
import { log_warning } from "../../../../../tools/logger";

export default ({ project, schemaId }) => {
  const [schema, schemaData] = useSchema(schemaId, project);
  const [tableData, setTableData] = useState([
    {
      assignedTo: "",
      title: "",
      description: "",
      dateOffset: 0,
      generateOnStatus: "",
    },
  ]);

  useEffect(() => {
    if (schemaData && schemaData.autoGenerateTask) {
      setTableData(schemaData.autoGenerateTask);
    }
  }, [schemaData]);

  const handleTableChange = useCallback((e) => {
    setTableData(e.target.value);
  }, []);

  const saveChanges = () => {
    if (
      tableData[0].assignedTo.length !== 0 &&
      tableData[0].title !== "" &&
      tableData[0].description !== "" &&
      tableData[0].generateOnStatus.length !== 0
    ) {
      log_warning("Save Attempted!");
      schema.update({ autoGenerateTask: tableData[0] });
    }
  };

  return (
    <>
      <QueryContent>
        <QuerySection style={{ width: "100%" }}>
          {schemaData?.settings?.enableTasks ? (
            <>
              <TableField2
                data={{
                  [LIFECYCLE_TABLE_SCHEMA.id]: Array.isArray(tableData)
                    ? tableData
                    : [
                      {
                        assignedTo: tableData.assignedTo,
                        title: tableData.title,
                        description: tableData.description,
                        dateOffset: tableData.dateOffset,
                        generateOnStatus: tableData.generateOnStatus,
                      },
                    ],
                }}
                field={LIFECYCLE_TABLE_SCHEMA}
                onFieldChange={handleTableChange}
                status={"editable"}
                editable={true}
                editabilityConditions={{ forceEdit: true }}
                staticTable
              />
            </>
          ) : null}
        </QuerySection>
      </QueryContent>
      <SaveQueryBar saveQuery={saveChanges} />
    </>
  );
};

const LIFECYCLE_TABLE_SCHEMA = {
  columns: [
    {
      name: "Assigned To",
      id: "assignedTo",
      editableWhile: ["editable"],
      type: "userlist",
      multi: false,
    },
    {
      name: "Title",
      id: "title",
      type: "string",
      editableWhile: [],
    },
    {
      name: "Description",
      id: "description",
      type: "string",
      editableWhile: [],
    },
    {
      name: "Date Offset",
      id: "dateOffset",
      type: "number",
      editableWhile: [],
    },
    {
      name: "Generate on status",
      id: "generateOnStatus",
      type: "select",
      options: {
        open: "Open",
        pending: "Pending",
        assigned: "Assigned",
        submitted: "Submitted",
        approved: "Approved",
        accepted: "Accepted",
      },
      editableWhile: ["editable"],
    },
  ],
  name: "Configure Auto-Generated Task",
  editableWhile: ["editable"],
  id: "generatedTasks",
};
